import { Col } from 'components/ui/Col'
import { useGetAreas } from 'api/areas'
import { useTranslation } from 'react-i18next'
import { Row } from 'components/ui/Row'
import { InputRadioExpandable } from 'components/ui/InputRadioExpandable'
import { useNavigate } from 'react-router'

type AreasListProps = {
  areaId?: string
}

export const AreasList = ({ areaId }: AreasListProps) => {
  const { data } = useGetAreas()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleAreaSelection = (areaId: string) => {
    navigate(`/authenticated/areas/${areaId}`)
  }

  return (
    <Col className={'tw-gap-2'} justifyContent={'flex-start'} alignItems={'flex-start'} width={'100%'}>
      <Row height={'2rem'} className={'tw-text-lg tw-font-medium'}>
        {t('selectArea')}
      </Row>
      <Col justifyContent={'flex-start'} alignItems={'flex-start'} className={'tw-mt-2'} width={'100%'}>
        {data?.map((area) => (
          <div key={area._id} className={'tw-mt-2 tw-mr-2 tw-border-b-[1px] tw-w-full'}>
            <InputRadioExpandable
              key={area._id}
              value={area._id}
              label={area.name}
              childrens={area.children}
              selectedValue={areaId}
              onChange={handleAreaSelection}
            />
          </div>
        ))}
      </Col>
    </Col>
  )
}
